<template>
    <div
        class="container-fluid"
        :style="getStyles"
    >
        <slot/>
    </div>
</template>

<script setup lang="ts">
import {computed} from "vue";

const { fullscreen } = defineProps<{
    fullscreen?: boolean
}>()

const getStyles = computed(() => {
    if (fullscreen) {
        const navbarHeight = document.getElementsByClassName('navbar')[0]?.clientHeight ?? 0;
        return {
            'margin-top': "-1rem",
            'margin-bottom': "-1rem",
            'height': `calc(100vh - ${navbarHeight}px)`
        }
    }
    return {}
})
</script>

<style>

</style>
